import "../css/blockimagecabecera.css";

function BlockImageCabecera(props) {
  function TagExist(tag) {
    if (tag)
      return (
        <div className="tag">
          <span className="material-icons"> circle</span>
          <p>{tag}</p>
        </div>
      );
  }

  return (
    <>
      <div className="blockimagecabecera">

        <div className="wrapper-imagen-overlay">
        <img src={props.src} alt="cabecera" /></div>

        <div className="cabecera-imagen-overlay">
          <div>
            <div>
              {TagExist(props.tag)}
              {props.title}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default BlockImageCabecera;
